module.exports = __webpack_public_path__ + "img/line.d6005421.svg";